import React, { useEffect, useState, useRef } from "react";
import Header from '../../components/header/Header';
import Sidebar from '../../components/sidebar/Sidebar';
import { getDepositWithdrawals } from "../../api/apiHandler";
import { showMessage, showErrorMessage, convertUTCToLocal } from "../common/Utils";
import $ from 'jquery';
import 'magnific-popup';
import "parsleyjs/src/parsley.css";
import "parsleyjs";
import 'select2';
import 'select2/dist/css/select2.min.css';
import DataTable from "react-data-table-component";
import Swal from "sweetalert2";

export function DepositWithdrawal() {

    const customStyles = {
        headCells: {
            style: {
                backgroundColor: '#B6A878',
                color: '#000000',
                fontWeight: 'bold',
                fontSize: '14px',
                textAlign: 'center',
                padding: '10px',
            },
        },
        cells: {
            style: {
                padding: '8px',
                textAlign: 'center',
                borderBottom: '1px solid #e0e0e0',
            },
        },
    };

    const timezone = localStorage.getItem('timezone');
    const selectRef = useRef(null);
    const initialized = useRef(false); // Prevents multiple initializations

    const [data, setData] = useState([]);
    const [totalRows, setTotalRows] = useState(0);
    const [loading, setLoading] = useState(false);
    const [search, setSearch] = useState("");
    const [pagination, setPagination] = useState({ page: 1, perPage: 50 });
    const [sortField, setSortField] = useState("id");
    const [sortOrder, setSortOrder] = useState("DESC");
    const [filters, setFilters] = useState({ title: 'all' });

    // Fetch data from server
    const fetchData = async () => {
        setLoading(true);
        try {
            const userReq = {
                page: pagination.page,
                per_page: pagination.perPage,
                search,
                sort: sortField,
                order: sortOrder,
                status: filters.title
            };
            const response = await getDepositWithdrawals(userReq);
            if (parseInt(response.code) === 1) {
                setData(response.data.items);
                setTotalRows(response.data.totalcount);
            } else {
                showErrorMessage(response.message);
            }
        } catch (error) {
            showErrorMessage("Something went wrong loading deposit/withdrawals, please try again later");
        }
        setLoading(false);
    };

    useEffect(() => {
        if (!initialized.current) {
            initialized.current = true;
            $(selectRef.current).select2();
            $('.image-popup').magnificPopup({
                type: 'image',
                gallery: { enabled: true }
            });
        }
    
        fetchData();  // ✅ Ensure fetching happens when dependencies change
    }, [pagination, search, sortField, sortOrder]);
    
    useEffect(() => {
        if (!initialized.current) return;
    
        $(selectRef.current).val(filters.title).trigger('change');
    
        const handleChange = function () {
            const value = $(this).val();
            console.log("value : ", value, "filters.title (before update): ", filters.title);
            // if (value !== filters.title) {
            //     setFilters({ title: value }); // ✅ This is asynchronous
            // }
            setFilters(prevFilters => {
                if (prevFilters.title !== value) {
                    console.log("Updating filters to:", value);
                    return { title: value };
                }
                return prevFilters; // No update if the value is the same
            });        
        };
    
        $(selectRef.current).on("change", handleChange);
    
        return () => {
            $(selectRef.current).off("change", handleChange);
        };
    }, []);

    // ✅ Trigger `fetchData()` when `filters` change
    useEffect(() => {
        console.log("Updated filters:", filters);
        fetchData(filters); // Fetch data after filters update
    }, [filters]);

    // Handle pagination
    const handlePageChange = (page) => {
        setPagination((prev) => ({ ...prev, page }));
    };
    
    const handlePerRowsChange = (perPage) => {
        setPagination({ page: 1, perPage });
    };
    
      // Handle sorting
    const handleSort = (column, sortDirection) => {
        setSortField(column.sortableField); // Field to sort by
        setSortOrder(sortDirection.toUpperCase()); // ASC or DESC
    };

    const formatNumber = (num) => {
        if (!num) return "0";

        const parsed = parseFloat(num);
        return parsed % 1 === 0 
            ? parsed.toFixed(0) 
            : parsed.toFixed(2).replace(/\.?0+$/, "");
    };

    const handleClearFilter = () => {
        setFilters({ title: 'all' });
        // Trigger initial value set
        $(selectRef.current).val('all').trigger('change');
    }
    
    return (
        <>
            <Header />
            <Sidebar />
            <section className="content">
                <div className="block-header">
                    <div className="row">
                        <div className="col-lg-7 col-md-6 col-sm-12">
                            <h2>Deposit/Withdrawals</h2>
                        </div>
                        <div className="col-lg-5 col-md-6 col-sm-12">
                            <ul className="breadcrumb float-md-right">
                                <li className="breadcrumb-item">
                                    <a href="/authpanel/dashboard">
                                    <i className="zmdi zmdi-home" />
                                        Dashboard
                                    </a>
                                </li>
                                <li className="breadcrumb-item active">Deposit/Withdrawals</li>
                            </ul>
                        </div>
                    </div>
                </div>
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-md-12 col-lg-12 col-xl-12">
                            <div className="card">
                                <div className="body">
                                    <div className="table-responsive">
                                        <div className="toolbar">
                                            <div className="row" style={{ marginRight: '0px' }}>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <div className="form-group">
                                                        <select ref={selectRef} className="form-control" id="title" name="title" style={{ minWidth: '200px' }}>
                                                            <option value="all">All</option>
                                                            <option value="addmoney_wallet_title">Deposits</option>
                                                            <option value="debitmoney_wallet_title">Withdrawals</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <button type="button" onClick={handleClearFilter} className="btn btn-raised btn-primary btn-xs waves-effect m-t-25 ml-3">
                                                        CLEAR
                                                    </button>
                                                </div>
                                                <div className="col-md-3 col-lg-3 col-xl-3"></div>
                                                <div className="col-md-3 col-lg-3 col-xl-3">
                                                    <div className="form-group" style={{ marginBottom: '5px' }}>
                                                        <input
                                                            type="text"
                                                            placeholder="🔍 Search..."
                                                            value={search}
                                                            onChange={(e) => setSearch(e.target.value)}
                                                            style={{
                                                                width: "100%",
                                                                padding: "10px 15px",
                                                                borderRadius: "25px",
                                                                border: "1px solid #ccc",
                                                                outline: "none",
                                                                boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)",
                                                                fontSize: "14px",
                                                            }}
                                                            className="form-control mb-3"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <DataTable
                                            columns={[
                                                { 
                                                    name: "PROFILE", 
                                                    selector: (row) => (
                                                        <a href={row.profile_image} className="image-popup">
                                                            <img 
                                                                src={row.profile_image} 
                                                                alt="Profile" 
                                                                className="img-responsive img-circle img-thumbnail"
                                                                height={45}
                                                                width={45}
                                                            />
                                                        </a>
                                                    ),
                                                    sortable: false,
                                                    width: '7%'
                                                },
                                                { name: "USER NAME", selector: (row) => `${row.first_name} ${row.last_name}`, sortable: true, sortableField: "first_name", width: '12%' },
                                                { name: "TYPE", selector: (row) => (row.status === 'credit') ? <label className="label label-success">Deposit</label> : <label className="label label-danger">Withdraw</label>, sortable: false, width: '8%' },
                                                { name: "AMOUNT", selector: (row) => `${formatNumber(row.amount)} ${row.currency}`, sortable: false, width: '8%' },
                                                { name: "TXN-ID", selector: (row) => row.transaction_id ? row.transaction_id : 'NA', sortable: false, width: '10%' },
                                                { name: "PAID VIA", selector: (row) => <label className="label label-warning">{row.payment_mode}</label>, sortable: true, sortableField: "payment_mode", width: '10%' },
                                                { name: "PAYMENT STATUS", selector: (row) => {
                                                    if (row.payment_status === 'Pending') {
                                                        return <label className="label label-warning">Pending</label>
                                                    } else if (row.payment_status === 'Approved') {
                                                        return <label className="label label-success">Approved</label>
                                                    } else {
                                                        return <label className="label label-danger">${row.payment_status}</label>
                                                    }
                                                }, sortable: false, width: '12%' },
                                                { name: "DESCRIPTION", selector: (row) => row.title, sortable: false, width: '15%' },
                                                { name: "CREATED AT", selector: (row) => convertUTCToLocal(row.created_at, timezone), sortable: true, sortableField: "created_at", width: '14%' },
                                                { 
                                                    name: "ACTIONS", 
                                                    selector: (row) => (
                                                        <>
                                                            <a
                                                                href={ `/authpanel/deposit-withdrawal/view/${btoa(row.user_id)}` }
                                                                className="btn btn-xs waves-effect waves-float waves-green"
                                                                style={{ marginBottom: '1px', border: '1px solid #D7C9A1' }}
                                                            >
                                                                <i className="zmdi zmdi-eye" style={{ color: '#D7C9A1' }} />
                                                            </a>
                                                        </>
                                                    ),
                                                    sortable: false,
                                                    width: '8%'
                                                },
                                            ]}
                                            data={data || []}
                                            defaultSortField="id"
                                            defaultSortAsc={false}
                                            pagination
                                            paginationServer
                                            paginationTotalRows={totalRows}
                                            paginationRowsPerPageOptions={[10, 20, 50, 100]}
                                            paginationPerPage={50} // Default page size
                                            onChangePage={handlePageChange}
                                            onChangeRowsPerPage={handlePerRowsChange}
                                            onSort={handleSort}
                                            sortServer
                                            persistTableHead
                                            progressPending={loading}
                                            customStyles={customStyles}
                                            noDataComponent={<div style={{ textAlign: "center", padding: "20px", color: "#888" }}>No data found</div>}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}